<!--
 * @Author: 孙照
 * @LastEditTime: 2024-01-02 11:14:58
 * @Description: 地图电站卡片
 * @FilePath: \sheyang\src\module\mapStationCard\index.vue
-->
<template>
  <div v-if="visible" class="map-station-card" ref="MapCard">
    <div class="header">
      <img class="arrow-img" src="@/assets/images/apng/infoTitleArrow.png" alt="" />
      <p class="station-name">{{ info.stubGroupName | filterEmpty }}</p>
    </div>
    <div class="body">
      <div class="station-img-box">
        <img
          v-if="!(info.img && info.img.length > 0 && info.img[0])"
          class="station-img"
          src="@/assets/images/greenTree.png"
          alt=""
        />
        <img v-else class="station-img" :src="info.img" alt="" />
      </div>
      <div v-if="cardName === 'overview'" class="overview-card">
        <div class="info">场站地址: {{ info.stationAddress | filterEmpty }}</div>
        <div class="info">今日充电桩充电量：{{ (info.electric || 0) | filterTwoDecimal }}kWh</div>
        <div class="info">
          今日光伏发电量：{{ (info.pvElectricToday || 0) | filterTwoDecimal }}kWh
        </div>
      </div>
      <div v-if="cardName === 'charging'" class="charging-card">
        <div class="info">
          充电状态:
          <span class="dot"></span>
          <span class="status">{{ info.stationStubStatus | filterStatus }}</span>
        </div>
        <div class="info">设备故障率：{{ (info.plugFaultRate * 100) | filterTwoDecimal }}%</div>
        <!-- <div class="info">设备使用率：{{ fakeDeviceUseRate | filterTwoDecimal }}%</div> -->
        <div class="info">设备使用率：{{ info.plugUseRate * 100 | filterTwoDecimal }}%</div>
      </div>
      <div v-if="cardName === 'pv'" class="pv-card">
        <div class="info">
          光伏设备状态:
          <span class="dot"></span>
          <span class="status">{{ info.pvStatusStr | filterPvStatus }}</span>
        </div>
        <div class="info">设备实时功率：{{ info.pvEquipmentPower | filterTwoDecimal }}kW</div>
        <div class="info">
          设备实时发电效率：{{ info.pvEquipmentEfficiency | filterTwoDecimal }}%
        </div>
      </div>
      <div v-if="cardName === 'storage'" class="storage-card">
        <div class="info">
          储能设备状态:
          <span class="dot"></span>
          <span class="status">{{ info.stationStubStatus | filterPvStatus }}</span>
        </div>
        <div class="info">并离网状态：{{ info.esequipmentParallelOffStatusStr }}</div>
        <div class="info">空调运行状态：{{ info.esequipmentAirConditionerStatusStr }}</div>
        <div class="info">消防状态：{{ info.esequipmentFireControlStatusStr }}</div>
      </div>
      <div v-if="showMore" class="more" @click.stop="hanldeVisible">查看详情</div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "mapStationCard",
  data() {
    return {
      fakeChargeElectricToday: 0,
      fakeCarbonReduction: 0,
      fakeDeviceUseRate: 0,
    };
  },
  filters: {
    // 异常值返回空字符串
    filterEmpty(value) {
      return value || "";
    },
    // 1 正常 0 异常
    filterStatus(value) {
      return value === 1 ? "正常" : "异常";
    },
    // 光伏状态 1 发电中 0 停机
    filterPvStatus(value) {
      return value || "无状态";
    },
    // 保留两位小数 如果没有值返回 0.00
    filterTwoDecimal(value) {
      return value ? value.toFixed(0) : "0";
    },
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    showMore: {
      type: Boolean,
      default: true,
    },
    info: {
      type: Object,
      default: () => ({}),
    },
    cardName: {
      type: String,
      default: "overview",
    },
  },
  methods: {
    ...mapMutations(["getStationId", "getCurrentStation"]),
    // 父组件调用子组件方法
    hanldeVisible() {
      // 存储 currentStationId
      // this.getCurrentStation(this.info.stubGroupId);
      this.getCurrentStation(this.info.stationId);
      this.$parent.onChangeVisible(true);
    },
    // 碳减排(克) = 电量(kWh) * 155
    getCarbonReduction(kwh) {
      return ((kwh * 155) / 1000).toFixed(2);
    },
    // 生成指定范围内的随机数
    randomNum(minNum, maxNum) {
      switch (arguments.length) {
        case 1:
          return parseInt(Math.random() * minNum + 1, 10);
        case 2:
          return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
        default:
          return 0;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.map-station-card {
  width: 320px;
  height: 200px;
  background: rgba(27, 85, 169, 0.6);
  border-radius: 31px 1px 1px 1px;
  backdrop-filter: blur(10px);
  .header {
    width: 100%;
    height: 50px;
    background: linear-gradient(270deg, rgba(76, 233, 255, 0.02) 0%, rgba(84, 161, 255, 0.52) 100%);
    border-radius: 31px 1px 1px 31px;
    backdrop-filter: blur(25px);
    display: flex;
    align-items: center;
    position: relative;
    .arrow-img {
      width: 62px;
      height: 62px;
      position: absolute;
      top: -5px;
      left: -5px;
      transform: rotate(90deg);
    }
    .station-name {
      margin-left: 60px;
      color: #ffffff;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
    }
  }
  .body {
    box-sizing: border-box;
    width: 100%;
    height: 150px;
    padding-top: 24px;
    padding-left: 10px;
    padding-right: 10px;
    position: relative;
    display: flex;
    .station-img-box {
      width: 87px;
      height: 87px;
      margin-right: 10px;
      .station-img {
        width: 87px;
        height: 87px;
      }
    }
    .info {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      margin-bottom: 14px;
      display: flex;
      align-items: center;
      .dot {
        width: 6px;
        height: 6px;
        margin-left: 8px;
        border-radius: 50%;
        background: #6effed;
        box-shadow: 0px 0px 9px 0px rgba(110, 255, 237, 0.74),
          0px 0px 4px 0px rgba(110, 255, 237, 0.76);
      }
      .status {
        margin-left: 8px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #6effed;
      }
    }
    .more {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #9cd6ff;
      position: absolute;
      bottom: 15px;
      right: 20px;
      cursor: pointer;
    }
  }
}
</style>
